import { Link, useLocation } from "react-router-dom"
import { Calendar, Clock, Home, Map, User, Bell } from "lucide-react"
import { cn } from "../lib/utils"
import { useNotification } from "../Services/NotificationContext";

const AppLayout = ({ children, hideFooter = false }) => {
  const location = useLocation();
  const { notificationCount } = useNotification();

 
  const navItems = [
    { href: "/dashboard", icon: Home, label: "Home" },
    { href: "/appointments", icon: Calendar, label: "Appointments" },
    { href: "/attendance", icon: Clock, label: "Attendance" },
    { href: "/notifications", icon: Bell, label: "Notifications" },
    { href: "/profile", icon: User, label: "Profile" },
  ];
 
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <main className="flex-1 w-full max-w-md mx-auto px-3 py-4 pb-24 overflow-x-hidden">
        {children}
      </main>
 
      {/* Footer will be hidden if hideFooter is true */}
      {!hideFooter && (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-pb z-50">
          <div className="w-full max-w-md mx-auto px-2">
            <div className="flex justify-between items-center h-16">
              {navItems.map((item) => {
                const isActive =
                  location.pathname === item.href ||
                  location.pathname.startsWith(`${item.href}/`);
                return (
                  <Link
                    key={item.href}
                    to={item.href}
                    className={cn(
                      "flex flex-col items-center justify-center flex-1 py-2 px-1 min-h-[3rem] touch-manipulation transition-colors",
                      isActive ? "text-pranaam-red" : "text-gray-500 hover:text-gray-900"
                    )}
                  >
                    {item.label === "Notifications" ? (
  <div className="relative">
    <Bell className="h-5 w-5 mb-1 flex-shrink-0" />
    <span className="absolute -top-1 -right-1 inline-flex items-center justify-center px-1.5 py-0.5 text-[10px] font-bold leading-none text-white rounded-full bg-red-600">
      {notificationCount ?? 0}
    </span>
  </div>
) : (
  <item.icon className="h-5 w-5 mb-1 flex-shrink-0" />
)}

                    <span className="text-xs font-medium leading-tight text-center">
                      {item.label}
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>
        </nav>
      )}
    </div>
  );
};
 
export default AppLayout;
 